


























import Vue from "vue";
import Component from "vue-class-component";
import ProductViewModel from "@/chipply/view-model/ProductViewModel";
import ProductColorSizeWrapperModel from "@/chipply/ProductColorSizeWrapperModel";
import DesignWrapperModel from "@/chipply/DesignWrapperModel";
import RadioButtonModel from "@/chipply/RadioButtonModel";
import { Prop } from "vue-property-decorator";
import ChipplyChip from "@/components/design-elements/ChipplyChip.vue";

@Component({
    components: { ChipplyChip },
    props: {
        noDesignSelected: Boolean,
    },
})
export default class ChooseYourDesign extends Vue {
    @Prop({ type: Array })
    public designs!: RadioButtonModel[];

    public selectedDesignName = "";

    public mounted() {
        if (this.designs.length > 0) {
            const selectedDesign = this.designs.find((design) => design.selected);
            if (selectedDesign) {
                this.selectedDesignName = selectedDesign.display;
            } else {
                this.designs[0].selected = true;
                this.selectedDesignName = this.designs[0].display;
            }
        }
    }

    public designSelected(design: RadioButtonModel) {
        this.designs.forEach((button) => {
            if (button.value == design.value) {
                button.selected = true;
                this.selectedDesignName = design.display;
                this.$emit("designChanged", design);
            } else {
                button.selected = false;
            }
        });
    }
}
